import React from 'react';
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import { useTranslation } from "react-i18next";

const ContactUs = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Contact" />
            <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />
                <BreadcrumbOne 
                    title={t('buttons.beContacted')}
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl={t('buttons.beContacted')}
                />
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--40">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = {t('contactPage.subtitle')}
                                        title = {t('contactPage.title')}
                                        description = ""
                                    />
                                </div>
                            </div>
                            <ContactOne />
                        </div>
                    </div>
                    {/* End Contact Area  */}
                    <FooterTwo />
                    <Copyright />
                </div>
        </>
    )
}
export default ContactUs;